module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point01/th_01-122cc8007f8e19fe58c719eb7809e32a.jpg";